import { updateFeed } from "@/mocks/movies";

export default function UpdateTicker() {
  const feed = [...updateFeed, ...updateFeed];

  return (
    <section aria-label="今日更新快讯" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-8xl items-center gap-4 px-4 py-3 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-accent-700">
          <i className="ri-flashlight-fill"></i>
          今日更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker items-center gap-8">
            {feed.map((text, index) => (
              <span key={`${text}-${index}`} className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-600 md:text-sm">
                <span className="h-1 w-1 rounded-full bg-primary-400"></span>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}